module.exports = __webpack_public_path__ + "static/media/topbar-bg2.2de0a46e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/topbar-bg2.jpg
// module id = 1356
// module chunks = 110